import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import productDetails from '../views/productDetails.vue'
import caseDetails from '../views/caseDetails.vue'
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/productDetails',
    name: 'productDetails',
    component: productDetails,
  },
  {
    path: '/caseDetails',
    name: 'caseDetails',
    component: caseDetails,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
